import React from 'react';
import BrandLogo from './BrandLogo';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <BrandLogo className="footer__logo" size="footer" />
          <p>Engineering visibility, attention and growth for brands that want to lead.</p>
          <div className="footer__social">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">in</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">tw</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">li</a>
          </div>
        </div>

        <div className="footer__links">
          <div className="footer__col">
            <h5>Services</h5>
            <ul>
              <li><a href="#services">Social Media</a></li>
              <li><a href="#services">Content Creation</a></li>
              <li><a href="#services">SEO</a></li>
              <li><a href="#services">Paid Ads</a></li>
            </ul>
          </div>
          <div className="footer__col">
            <h5>Company</h5>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer__col">
            <h5>Connect</h5>
            <ul>
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter / X</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© 2025 Beyond Digital Agency. All rights reserved.</p>
      </div>
    </footer>
  );
}